import React from 'react';
import { View, Text, StyleSheet, Platform, ViewStyle, StyleProp } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { ResioLogo } from '@/assets/ResioLogo';

type Props = {
  show?: boolean;
  style?: StyleProp<ViewStyle>;
};

export const AuthHeader: React.FC<Props> = ({ show = true, style }) => {
  if (!show) return null;
  return (
    <View style={[styles.header, style]}> 
      <View style={styles.logoContainer}>
        <ResioLogo width={64} height={64} style={styles.logoIcon} />
        <Text style={styles.logoText}>RESIO</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER_SECONDARY,
    backgroundColor: 'transparent',
    ...Platform.select({
      web: { position: 'sticky' as any, top: 0, zIndex: 10 },
    }),
  },
  logoContainer: { flexDirection: 'row', alignItems: 'center' },
  logoIcon: { marginRight: 8, width: 64, height: 64 },
  logoText: {
    fontSize: Platform.select({ web: 48, default: 32 }) as number,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT.PRIMARY,
    letterSpacing: 0.5,
  },
});


